<template>
  <div class="data-modification">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>申请人：</p>
        <el-input
          v-model="applyPeople"
          size="mini"
          style="width: 150px"
          placeholder="请输入申请人" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column label="序号" align="center" width="50px">
            <template slot-scope="scope">
              <el-badge value="危" class="item" :hidden="!scope.row.isRisky">
                <div style="height: 18px">
                  {{ scope.$index + 1 }}
                </div>
              </el-badge>
            </template>
          </el-table-column>
          <el-table-column prop="applyNo" label="申请批次" align="center" />
          <el-table-column prop="applyPeople" label="申请人" align="center" />
          <el-table-column prop="applyCount" label="申请数量" align="center" />
          <el-table-column prop="createTime" label="申请时间" align="center" />
          <el-table-column prop="applyReason" label="申请原因" align="center" />
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待审核</span>
              <span v-if="scope.row.status == 1">已通过</span>
              <span v-if="scope.row.status == -1">已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="205" align="center">
            <template slot-scope="scope">
              <div style="align-items: center; padding-left: 10px">
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.applyNo)"
                  >详情</el-button
                >
                <el-button v-if="scope.row.status == 0" size="mini" type="primary" @click="examineClick(scope.row.applyNo)"
                  >审批</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
      title="运输车详情"
      :visible.sync="detailDialogVisible"
      width="1050px"
      center
      top="10vh"
      :close-on-click-modal="false"
      @close="handleCloseDetail">
      <div class="detail">
        <div class="baseInfo">
          <div class="tableContainer">
            <el-table
              v-loading="dialogTableLoad"
              :data="detailData.table"
              style="width: 100%"
              border>
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{ scope.$index + 1 }}</div>
              </el-table-column>
              <el-table-column prop="consignorName" label="委托商" width="120" align="center" />
              <el-table-column prop="batchNumber" label="批次号" width="120" align="center" />
              <el-table-column prop="waybillNo" label="运单号" align="center" />
              <el-table-column prop="frameNumber" label="车架号" align="center" />
              <el-table-column prop="departurePlace" label="起运地" align="center" />
              <el-table-column prop="arrivePlace" label="交车地" align="center" />
              <el-table-column prop="transportModeExport" label="运输方式" align="center" />
              <el-table-column prop="planDate" label="计划时间" align="center" />
            </el-table>
          </div>
          <div
            class="paginationContainer"
            style="display: flex; align-items: center; padding: 10px 20px">
            <span>共{{ detailTotal }}条</span>
            <el-pagination
              background
              :page-sizes="[10, 20, 30, 40]"
              layout="sizes,prev, pager, next,jumper"
              :total="detailTotal"
              @size-change="detailSizeChange"
              @current-change="detailCurrentChange"
              @prev-click="detailCurrentChange"
              @next-click="detailCurrentChange" />
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 审批弹窗 -->
    <el-dialog
      title="审核"
      :visible.sync="examineDialogVisible"
      width="600px"
      center
      top="10vh"
      :close-on-click-modal="false"
      @close="handleCloseExamine">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoContentItem">
            <div style="display: flex; margin: 10px 20px 0 15px">
              <span class="span1" style="width: 70px"><span style="color: red">*</span>原因：</span>
              <el-input
                type="textarea"
                :style="'width:100%'"
                v-model="examineData.remark"
                placeholder="请填写同意/拒绝原因"
                autocomplete="off"
                size="small"
                :autosize="{ minRows: 5, maxRows: 10 }" />
            </div>
          </div>
        </div>
        <div style="display: flex; align-items: center; justify-content: center">
          <el-button size="medium" type="primary" @click="agreeClick">同意</el-button>
          <el-button size="medium" type="danger" @click="refusedClick">拒绝</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    dataModificationList,
    dataModificationDetailList,
    dataModificationAgreeOrRefuse,
  } from '@/service/audit';

  export default {
    data() {
      return {
        applyPeople: '',
        tableLoad: false,
        TableDatas: [],
        page: 1,
        size: 10,
        total: 0,
        detailDialogVisible: false,
        dialogTableLoad: false,
        detailData: {
          table: [],
        },
        applyNoi: '',
        detailPage: 1,
        detailSize: 10,
        detailTotal: 0,
        examineDialogVisible: false,
        examineData: {
          remark: '',
        },
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      async init() {
        // await this._dataModificationPageList();
      },
      async _dataModificationPageList() {
        this.tableLoad = true;
        const res = await dataModificationList({
          applyPeople: this.applyPeople,
          page: this.page,
          rows: this.size,
        });
        // console.log(res);
        if (res.status !== 0) this.$message.error(res.message);
        this.total = res.data.total;
        this.TableDatas = res.data.records;
        this.tableLoad = false;
      },
      searchBtn() {
        this.page = 1;
        this._dataModificationPageList();
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._dataModificationPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._dataModificationPageList();
      },
      async detailClick(applyNo) {
        // console.log(applyNo);
        this.applyNoi = applyNo;
        this.detailDialogVisible = true;
        this.getPageListDetail();
      },
      detailSizeChange(size) {
        this.detailSize = size;
        this.getPageListDetail();
      },
      detailCurrentChange(page) {
        this.detailPage = page;
        this.getPageListDetail();
      },
      async getPageListDetail() {
        this.dialogTableLoad = true;
        const res = await dataModificationDetailList({
          applyNo: this.applyNoi,
          page: this.detailPage,
          rows: this.detailSize,
        });
        // console.log(res);
        this.detailData.table = res.data.records;
        this.detailTotal = res.data.total;
        this.dialogTableLoad = false;
      },
      handleCloseDetail() {
        this.detailData.table = [];
        this.detailTotal = 0;
        this.detailPage = 1;
        this.detailSize = 10;
        this.applyNoi = '';
      },
      handleCloseExamine() {
        this.examineData.remark = '';
        this.applyNoi = '';
      },
      examineClick(applyNo) {
        this.applyNoi = applyNo;
        this.examineDialogVisible = true;
      },
      async agreeClick() {
        if (this.examineData.remark) {
          const res = await dataModificationAgreeOrRefuse({
            auditRemark: this.examineData.remark,
            status: 1,
            applyNo: this.applyNoi,
          });
          if (res.status !== 0) {
            this.$message.error(res.message);
          } else {
            this.$message({
              message: res.message,
              type: 'success',
            });
            this.examineDialogVisible = false;
            this.page = 1;
            this.size = 10;
            this._dataModificationPageList();
          }
        } else {
          this.$message({
            message: '原因不能为空！',
            type: 'warning',
          });
        }
      },
      async refusedClick() {
        if (this.examineData.remark) {
          const res = await dataModificationAgreeOrRefuse({
            auditRemark: this.examineData.remark,
            status: -1,
            applyNo: this.applyNoi,
          });
          if (res.status !== 0) {
            this.$message.error(res.message);
          } else {
            this.$message({
              message: res.message,
              type: 'success',
            });
            this.examineDialogVisible = false;
            this.page = 1;
            this.size = 10;
            this._dataModificationPageList();
          }
        } else {
          this.$message({
            message: '原因不能为空！',
            type: 'warning',
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .data-modification {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;
    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;
        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }
      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;
        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }
          .el-badge__content {
            background-color: #f56c6c !important;
          }
          .el-table .cell {
            padding: 0;
          }
          .el-table th {
            padding: 0;
          }
          .el-table td {
            padding: 0;
          }
        }
      }
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span {
          font-size: 13px;
        }
      }
    }
    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;
      .baseInfo {
        display: flex;
        flex-direction: column;
        .attachment {
          display: flex;
          flex-direction: column;
          padding-top: 10px;
          &Item {
            width: 80%;
            margin-bottom: 10px;
            margin-left: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              color: #969696;
              font-size: 14px;
            }
          }
        }
        &Title {
          display: flex;
          align-items: flex-end;
          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          &Item {
            margin-bottom: 20px;
            .span1 {
              font-weight: 700;
            }
            span {
              font-size: 14px;
            }
            .specialOne {
              width: 50%;
            }
          }
          .specialItem {
            display: flex;
          }
        }
      }
      .operation {
        display: flex;
        flex-direction: column;
        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }
          .cell {
            font-size: 10px;
            padding: 0;
          }
        }
        &Title {
          display: flex;
          align-items: flex-end;
          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
  }
</style>
